<div [attr.data-theme]="theme$ | async">
  <router-outlet></router-outlet>
</div>
@if (displayGlobalSpinner$ | async) {
  <app-global-spinner [messages]="globalSpinnerMessages$ | async" />
}
